<div *ngIf="producers.length > 0">
  <h3>Erzeugungseinheiten</h3>
  <div *ngIf="!showOnlyTotal">
    <section *ngFor="let producer of producers; first as isFirst; last as isLast">
      <h4>
        <span *ngIf="producer.count">{{ producer.count.toString() }} x</span>
        {{ producer.manufacturer }}
        <span *ngIf="producer.manufacturer && producer.deviceTypeName">-</span>
        {{ producer.deviceTypeName }}
      </h4>
      <div *ngIf="producer.phases">
        <app-value-with-label
          *ngIf="producer.phases"
          [label]="'Anzahl der Phasen:'"
          [value]="producer.phases | phasesTypePipe"></app-value-with-label>
        <app-value-with-label
          *ngIf="producer.connectedPhases"
          [label]="'  Angeschlossene Phasen:'"
          [value]="producer.connectedPhases | connectedPhasenPipe"></app-value-with-label>
      </div>
      <div>
        <app-value-with-label
          *ngIf="producer.acActivePowerMax"
          [label]="'AC-maximale Wirkleistung:'"
          [value]="(producer.acActivePowerMax | number : undefined : 'de-DE') + ' kW'"></app-value-with-label>
      </div>
      <div>
        <app-value-with-label
          *ngIf="producer.acApparentPowerMax"
          [label]="'AC-maximale Scheinleistung:'"
          [value]="
            (producer.acApparentPowerMax | number : undefined : 'de-DE') + ' kVA'
          "></app-value-with-label>
      </div>
      <div>
        <app-value-with-label
          *ngIf="producer.acActivePowerMax > 0"
          [label]="'Gesamt AC-maximale Wirkleistung:'"
          [value]="
            (producer.count * producer.acActivePowerMax | number : undefined : 'de-DE') + ' kW'
          "></app-value-with-label>
      </div>
      <div *ngIf="consumptionOver30kw">
        Ein Eigenverbrauch von über 30.000 kWh im Jahr über diese Erzeugungsanlage.
      </div>
    </section>
  </div>
  <section>
    <div>
      <app-value-with-label
        [label]="'<b>Gesamte AC-maximale Wirkleistung der Erzeugungseinheiten:</b>'"
        [value]="
          '<b>' +
          (producers.length | totalPowerProducersPipe : producers | number : undefined : 'de-DE') +
          ' kW</b>'
        "></app-value-with-label>
    </div>
    <!--
      Eigene Pipe: die Scheinleistung weicht im Normalfall von der Wirkleistung ab und ist die für
      die Anschlussdimensionierung maßgebliche Größe. Dieselbe Summe druckt das Dokument
      (netz-services: templates/fragments/gridRegistration.html).
    -->
    <div>
      <app-value-with-label
        [label]="'<b>Gesamte AC-maximale Scheinleistung der Erzeugungseinheiten:</b>'"
        [value]="
          '<b>' +
          (producers.length | totalApparentPowerProducersPipe : producers | number : undefined : 'de-DE') +
          ' kVA</b>'
        "></app-value-with-label>
    </div>
  </section>
</div>
